module.exports = __webpack_public_path__ + "img/model3.84b88533.png";